import Vue from 'vue'

export default {
  saveNote({ conversationId, text, mentions }) {
    return Vue.http.post('app-services/v2/notes/internal', { conversationId, text, mentions })
  }
}
